import classNames from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";

/**
 * Collapsible side panel with a chevron toggle.
 *
 * @param root0 - The component props.
 * @param root0.autoOpen - Whether the panel starts in the open state.
 * @param root0.children - The panel content.
 * @param root0.className - Additional CSS class name.
 * @param root0.title - The panel header title.
 * @returns The rendered panel component.
 */
const ConcealablePanel = ({
    autoOpen = false,
    children,
    className = "",
    title,
}) => {
    const [visible, setVisible] = useState(autoOpen);

    const toggleVisibility = () => {
        setVisible(!visible);
    };

    const icon = visible ? "chevron-right" : "chevron-left";
    const contentStyle = `concealable-panel-content ${className}`;

    return (
        <div className="lights-map-concealable-panel">
            <div
                className={classNames(
                    "concealable-panel",
                    visible ? "opened" : "closed",
                )}
            >
                <div
                    className="concealable-panel-switch"
                    onClick={toggleVisibility}
                >
                    <i className={`fa fa-${icon}`} />
                    {!visible && title}
                </div>
                <div className={contentStyle}>{children}</div>
            </div>
        </div>
    );
};

ConcealablePanel.propTypes = {
    autoOpen: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    title: PropTypes.string,
};

export default ConcealablePanel;
